export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function matchesDateRange(dateValue, dateFrom, dateTo) {
  if (!dateFrom && !dateTo) {
    return true;
  }
  if (!dateValue) {
    return false;
  }

  const rowDate = new Date(dateValue);
  if (Number.isNaN(rowDate.getTime())) {
    return false;
  }

  const from = dateFrom ? new Date(`${dateFrom}T00:00:00`) : null;
  const to = dateTo ? new Date(`${dateTo}T23:59:59`) : null;

  if (from && rowDate < from) {
    return false;
  }
  if (to && rowDate > to) {
    return false;
  }

  return true;
}

export function triggerCsvDownload(filename, headers, rows) {
  const content = [headers, ...rows]
    .map((row) => row.map((cell) => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(','))
    .join('\n');

  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export function triggerExcelLikeDownload(filename, headers, rows) {
  const content = [headers, ...rows]
    .map((row) => row.map((cell) => String(cell ?? '').replace(/\t/g, ' ')).join('\t'))
    .join('\n');

  const blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
